<div class="relative flex flex-col w-full h-full md:min-w-128 md:max-w-320">
  <!-- Title -->
  <div
    class="flex flex-col items-center sm:items-start -mx-6 -mt-6 p-8 space-y-1 text-center sm:text-left bg-primary-800">
    <div class="text-xl leading-6 font-medium text-on-primary-800">Quick scan</div>
  </div>

  <!-- Dismiss button -->
  <div class="absolute top-0 right-0">
    <button mat-icon-button [matDialogClose]="undefined">
      <mat-icon class="text-secondary" svgIcon="mat_outline:close" />
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start py-8">
    <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 space-y-1 text-center sm:text-left">
      <div class="flex gt-xs:flex-row content-container">
        <div class="mr-3 w-full">
          <form cdkFocusInitial [formGroup]="scannedCodeFormGroup" class="content-border h-full">
            <app-scan-qr-code
              class="qr-scan-container h-full"
              [formControl]="scannedCodeFormGroup?.get('scannedQrCode') | formControl"
              [showScannedDetails]="false">
            </app-scan-qr-code>
          </form>
        </div>
        <div class="content-border w-full">
          @if (!labelCode && !scanFailure) {
            <div class="h-full scan-details-description">
              Scan a QR code to display item details. <br />
              Multiple items can be scanned sequentially.
            </div>
          }
          @if (scanFailure && labelCodeTypeMap[labelCode?.type]?.name) {
            <div class="p-3 h-full scan-details-description">
              Something went wrong. Could not find {{ labelCodeTypeMap[labelCode?.type]?.name }}.
            </div>
          }
          @if (labelCode && !scanFailure && labelCode.type) {
            <div class="p-3">
              <div class="pb-3">
                <app-single-detail
                  svgIcon="hero_solid:qrcode"
                  label="Type"
                  [value]="labelCodeTypeMap[labelCode.type].name | titlecase">
                </app-single-detail>
              </div>
              @switch (labelCode.type) {
                @case ("Account") {
                  <app-scanned-account-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()"></app-scanned-account-details>
                }
                @case ("Bottle") {
                  <app-scanned-bottle-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()">
                  </app-scanned-bottle-details>
                }
                @case ("Case") {
                  <app-scanned-case-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()">
                  </app-scanned-case-details>
                }
                @case ("Receipt") {
                  <app-scanned-inbound-receipt-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()">
                  </app-scanned-inbound-receipt-details>
                }
                @case ("Location") {
                  <app-scanned-location-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()">
                  </app-scanned-location-details>
                }
                @case ("TransitUnit") {
                  <app-scanned-transit-unit-details
                    [labelCode]="labelCode"
                    (navigationInstructions)="updateCandidateNavigation($event)"
                    (scanFailure)="handleScanFailure()">
                  </app-scanned-transit-unit-details>
                }
                @default {}
              }
            </div>
          }
          @if (scanFailure && !labelCodeTypeMap[labelCode?.type]?.name) {
            <div class="scan-details-description">Something went wrong. Could not identify QR code.</div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div
    class="flex items-center justify-center sm:justify-end -mx-6 -mb-6 p-8 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
    <button mat-stroked-button [matDialogClose]="false">Close</button>

    @if (labelCode && !scanFailure && labelCode.type) {
      <mat-button-toggle-group class="extended-option-menu">
        <button mat-button mat-raised-button class="ns-yellow-background" (click)="navigateToScannedItem()">
          Navigate to {{ labelCodeTypeMap[labelCode.type].name }} details
        </button>
        <mat-button-toggle class="ns-yellow-background" [matMenuTriggerFor]="extendedNavigationOptions">
          <mat-icon class="extended-option-navigation">arrow_drop_down</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }

    <mat-menu #extendedNavigationOptions="matMenu" xPosition="before">
      <button (click)="navigateToScannedItem()" mat-menu-item>
        <mat-icon [svgIcon]="'feather:navigation'"></mat-icon>Open in current tab
      </button>
      <button (click)="navigateToScannedItem(true)" mat-menu-item>
        <mat-icon [svgIcon]="'feather:plus'"></mat-icon>Open in new tab
      </button>
    </mat-menu>
  </div>
</div>

<ng-template #PassCheck let-isSafe="isSafe" let-message="message">
  <div class="flex items-center mb-1">
    <mat-icon
      class="icon-size-7"
      [svgIcon]="isSafe ? 'feather:check-circle' : 'feather:circle'"
      [class]="isSafe ? 'text-green-400' : 'text-red-600'" />
    <span class="ml-2">{{ message }}</span>
  </div>
</ng-template>
